import React from "react";

import { Text, Title, Wrap } from "./styles";

interface BannerProps {
    tone?: "info" | "warning" | "danger";
    title?: React.ReactNode;
    className?: string;
    children?: React.ReactNode;
}

export const Banner = ({ tone = "info", title, className, children }: BannerProps) => (
    <Wrap $tone={tone} className={className}>
        {title && <Title>{title}</Title>}
        {children && <Text>{children}</Text>}
    </Wrap>
);
